module.exports = __webpack_public_path__ + "static/img/outer-frame.189b355b.png";